import axios from 'axios'

import type { CartItem } from './validate'

export const updateCartItem = async (
  { itemOffered: { sku, additionalProperty }, ...otherProps }: CartItem,
  cartId: string
) => {
  await axios.post('/api/checkout/updateCartItem', {
    orderFormId: cartId,
    newItem: {
      ...otherProps,
      itemOffered: {
        sku,
        additionalProperty,
      },
    },
  })
}

export const addCartItem = async (
  { itemOffered: { sku, additionalProperty }, ...otherProps }: CartItem,
  cartId: string
) => {
  await axios.post('/api/checkout/addCartItem', {
    orderFormId: cartId,
    newItem: {
      ...otherProps,
      itemOffered: {
        sku,
        additionalProperty,
      },
    },
  })
}

export const removeCartItem = async (
  cartId: string,
  { itemOffered: { sku, additionalProperty }, ...otherProps }: CartItem
) => {
  await axios.post('/api/checkout/removeCartItem', {
    orderFormId: cartId,
    newItem: {
      ...otherProps,
      itemOffered: {
        sku,
        additionalProperty,
      },
    },
  })
}

// Aggiunge piu' SKU con una sola chiamata (una lettura orderForm + una mutation)
export const addCartItems = async (items: CartItem[], cartId: string) => {
  await axios.post('/api/checkout/addCartItems', {
    orderFormId: cartId,
    newItems: items.map(
      ({ itemOffered: { sku, additionalProperty }, ...otherProps }) => ({
        ...otherProps,
        itemOffered: { sku, additionalProperty },
      })
    ),
  })
}
